import React, { useEffect, useState, useContext } from 'react';
import styles from './PharosAsideCard.module.css';
import useDesignSettingsData from 'hooks/useDesignSettingsData';


const PharosAsideCard = () => {

     const [loading, setLoading] = useState(true);
     const { designSettings, settingsLoading, error } = useDesignSettingsData();
    console.log(designSettings);

    return (
        <aside className={styles.aside} aria-label="Informations Le Pharos">
            <div className={styles.container}>
                <>
                        {designSettings && designSettings.pharosLogo && (
                            <img src={`${designSettings.pharosLogo}`} alt="Le Pharos" className={styles.logo} />
                        )}
                        </>
                <address className={styles.info}>
                    4 rue Charles Péguy, 62000 Arras<br />
                    03 21 16 89 00<br />
                    <a href="mailto:pharos@ville-arras.fr" aria-label="Envoyer un email à pharos@ville-arras.fr">pharos@ville-arras.fr</a>
                    <a href="https://www.facebook.com/lepharos" target="_blank" rel="noopener noreferrer" aria-label="Page Facebook du Pharos">
                        www.facebook.com/lepharos
                    </a>
                </address>
            </div>
        </aside>
    );
}
export default PharosAsideCard;